import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Anchor, Breadcrumbs, rem } from "@mantine/core";
import React from "react";
import { useNavigate } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
  isActive?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();

  const handleClick = (href?: string) => {
    if (href) {
      navigate(href);
    }
  };

  return (
    <Breadcrumbs
      separator={
        <ChevronRightIcon style={{ width: rem(12), height: rem(12) }} />
      }
      mb="md"
    >
      {items.map((item, index) => (
        <Anchor
          key={index}
          onClick={() => handleClick(item.href)}
          c={item.isActive ? "dimmed" : "blue"}
          style={{
            cursor: item.href ? "pointer" : "default",
            textDecoration: item.href ? "underline" : "none",
          }}
          size="sm"
        >
          {item.label}
        </Anchor>
      ))}
    </Breadcrumbs>
  );
};
